import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPeriscope extends Layout {
    sourceBrokerageMovements: DataSource;
    tableMovements: Table;
}
